var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindDirectionSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "windDirectionSvg",
    viewBox: "0 0 160 160",
    width: 160,
    height: 160,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#87ceeb",
    d: "M0,0 l20,20 l20,-20 l0,20 l-20,20 l-20,-20 l0,-20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#87ceeb",
    d: "M80,80 l20,20 l20,-20 l0,20 l-20,20 l-20,-20 l0,-20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindDirectionSvg);
export default __webpack_public_path__ + "static/media/WindDirectionSvg.e2d41082252e1b211ef38dfe9dea96b1.svg";
export { ForwardRef as ReactComponent };